import {gql, useMutation} from '@apollo/client';

export const SAVE_PARENT = gql`
    mutation SavePlayer($input: ParentInput!) {
        saveParent(input: $input) {
            id
        }
    }`;
export const useSaveParent = () => useMutation(SAVE_PARENT);
